module.exports = __webpack_public_path__ + "static/media/cartIcon.ae77ffa8.svg";